import routeSelectorImport from './routeSelector';
import routesSelectorImport from './routesSelector';
import getSubMenuImport from './routesSubMenu';
import getRouteByIDVStatusImport from './getRouteByIDVStatus';
import getCurrentRouteImport from './getCurrentRoute';
import getCurrentPathImport from './getCurrentPath';
import getRoutesByStageImport from './routesStagesSelector';
import containsMarketPathImport from './containsMarketPath';
import areRoutesLoadedImport from './areRoutesLoaded';
import getUserRoleRoutesImport from './getUserRoleRoutes';
import getCurrentRouteMarketImport from './getCurrentRouteMarket';

export const routeSelector = routeSelectorImport;
export const routesSelector = routesSelectorImport;
export const getSubMenu = getSubMenuImport;
export const getRouteByIDVStatus = getRouteByIDVStatusImport;
export const getCurrentRoute = getCurrentRouteImport;
export const getCurrentPath = getCurrentPathImport;
export const getRoutesByStage = getRoutesByStageImport;
export const containsMarketPath = containsMarketPathImport;
export const areRoutesLoaded = areRoutesLoadedImport;
export const getUserRoleRoutes = getUserRoleRoutesImport;
export const getCurrentRouteMarket = getCurrentRouteMarketImport;
